import { Yup } from 'cng-web-lib'
import ValidationMessageTranslationText from './ValidationMessageTranslationText'


function useComplianceTransportValidationInSchema(){
    const validationMessageTranslation = ValidationMessageTranslationText()

    return Yup.object().shape({
        shippingInfoComplianceTransport: Yup.object().shape({
            inTptMode: Yup.string()
                .required(validationMessageTranslation.requiredMessage)
        })
    })
}

export default useComplianceTransportValidationInSchema